module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('ul', {
    staticClass: "alternate_style"
  }, [_c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/08foreword#for"
    }
  }, [_vm._v("FOREWORD")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/09introduction#int"
    }
  }, [_vm._v("INTRODUCTION "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("THE WORLD IS MY PORK CHOP")])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/10chapter01#ch1"
    }
  }, [_vm._v("CHAPTER 1 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("ALL ABOUT PORK CHOPS")])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/13chapter02#ch2"
    }
  }, [_vm._v("CHAPTER 2 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("THE CLASSICS")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/14chapter02a#ch2lev1"
    }
  }, [_vm._v("Chicago-Style Pork Chop Sandwiches")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/15chapter02b#ch2lev2"
    }
  }, [_vm._v("Saut"), _c('span', {
    staticClass: "serif"
  }, [_vm._v("é")]), _vm._v("ed Pork Chops with Apples")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/16chapter02c#ch2lev3"
    }
  }, [_vm._v("Pineapple Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/17chapter02d#ch2lev4"
    }
  }, [_vm._v("Blackened Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/18chapter02e#ch2lev5"
    }
  }, [_vm._v("Garlic Lovers’ Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/19chapter02f#ch2lev6"
    }
  }, [_vm._v("Skillet-Braised Pork Chops with Vidalia Onions")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/20chapter02g#ch2lev7"
    }
  }, [_vm._v("Herb and Parmesan–Crusted Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/21chapter02h#ch2lev8"
    }
  }, [_vm._v("Honey-Brined Pecan-Crusted Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/22chapter02i#ch2lev9"
    }
  }, [_vm._v("Homemade Teriyaki Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/23chapter02j#ch2lev10"
    }
  }, [_vm._v("Grilled Pork Chops with Homemade BBQ Sauce")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/24chapter02k#ch2lev11"
    }
  }, [_vm._v("Southern-Fried Pork Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/25chapter02l#ch2lev12"
    }
  }, [_vm._v("Dry-Rubbed Iowa Chops")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/26chapter02m#ch2lev13"
    }
  }, [_vm._v("Stand-Up Stuffed Pork Chops with Bacon and Blue Cheese")])])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/27chapter03#ch3"
    }
  }, [_vm._v("CHAPTER 3 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("FRESH IDEAS")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/28chapter03a#ch3lev1"
    }
  }, [_c('strong', [_vm._v("Grilled Romaine and Pork Chopped Salad")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/29chapter03b#ch3lev2"
    }
  }, [_c('strong', [_vm._v("Pork Chop and Mixed Greens Salad with Raspberry Vinaigrette")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/30chapter03c#ch3lev3"
    }
  }, [_c('strong', [_vm._v("Sandi"), _c('span', {
    staticClass: "serif"
  }, [_vm._v("’")]), _vm._v("s Asian-Inspired Pork Chop Salad")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/31chapter03d#ch3lev4"
    }
  }, [_c('strong', [_vm._v("Pork Chop Taco Salad with Avocado Dressing")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/32chapter03e#ch3lev5"
    }
  }, [_c('strong', [_vm._v("Pork Chop Wraps with Spinach and Feta Cheese")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/33chapter03f#ch3lev6"
    }
  }, [_c('strong', [_vm._v("Spicy Pork Chop Lettuce Wraps")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/34chapter03g#ch3lev7"
    }
  }, [_c('strong', [_vm._v("Pork Chop and Veggie Stir-Fry")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/35chapter03h#ch3lev8"
    }
  }, [_c('strong', [_vm._v("Flat Bread Pork Chop Pizza")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/36chapter03i#ch3lev9"
    }
  }, [_c('strong', [_vm._v("Pork Chops with Broccoli")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/37chapter03j#ch3lev10"
    }
  }, [_c('strong', [_vm._v("Balsamic and Vanilla"), _c('span', {
    staticClass: "serif"
  }, [_vm._v("–")]), _vm._v("Glazed Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/38chapter03k#ch3lev11"
    }
  }, [_c('strong', [_vm._v("Broiled Pork Chops with Pineapple Chutney")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/39chapter03l#ch3lev12"
    }
  }, [_c('strong', [_vm._v("Pork Chops with Fresh Mango-Habanero Salsa")])])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/40chapter04#ch4"
    }
  }, [_vm._v("CHAPTER 4 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("ONE-POT PORK CHOPS")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/41chapter04a#ch4lev1"
    }
  }, [_c('strong', [_vm._v("Pork Chop Pot Roast")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/42chapter04b#ch4lev2"
    }
  }, [_c('strong', [_vm._v("Slow Cooker Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/43chapter04c#ch4lev3"
    }
  }, [_c('strong', [_vm._v("Pork Chop Pepper Steak")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/44chapter04d#ch4lev4"
    }
  }, [_c('strong', [_vm._v("Tater Tot Pork Chop Casserole")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/45chapter04e#ch4lev5"
    }
  }, [_c('strong', [_vm._v("Cheesy Pork Chop Skillet Dinner")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/46chapter04f#ch4lev6"
    }
  }, [_c('strong', [_vm._v("Pork Chops and Dumplings")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/47chapter04g#ch4lev7"
    }
  }, [_c('strong', [_vm._v("Pork Chop Chili")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/48chapter04h#ch4lev8"
    }
  }, [_c('strong', [_vm._v("Pork Chop Gumbo")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/49chapter04i#ch4lev9"
    }
  }, [_c('strong', [_vm._v("Pork Chop Noodle Soup")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/50chapter04j#ch4lev10"
    }
  }, [_c('strong', [_vm._v("Pork Chop, Leek, and Potato Soup")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/51chapter04k#ch4lev11"
    }
  }, [_c('strong', [_vm._v("Ray’s Special Oven Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/52chapter04l#ch4lev12"
    }
  }, [_c('strong', [_vm._v("Pork Chops and White Beans")])])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/53chapter05#ch5"
    }
  }, [_vm._v("CHAPTER 5 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("INTERNATIONAL PORK CHOPS")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/54chapter05a#ch5lev1"
    }
  }, [_c('strong', [_vm._v("Pork Chop Suey")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/55chapter05b#ch5lev2"
    }
  }, [_c('strong', [_vm._v("Thai Pork Chops in Banana Leaves")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/56chapter05c#ch5lev3"
    }
  }, [_c('strong', [_vm._v("Spicy Grilled Jerk Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/57chapter05d#ch5lev4"
    }
  }, [_c('strong', [_vm._v("Mojo-Marinated Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/58chapter05e#ch5lev5"
    }
  }, [_c('strong', [_vm._v("Arroz con Puerco Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/59chapter05f#ch5lev6"
    }
  }, [_c('strong', [_vm._v("Sangrita Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/60chapter05g#ch5lev7"
    }
  }, [_c('strong', [_vm._v("Pork Chop Guacadillas")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/61chapter05h#ch5lev8"
    }
  }, [_c('strong', [_vm._v("Pork Chop Carnitas")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/62chapter05i#ch5lev9"
    }
  }, [_c('strong', [_vm._v("Pork Chop "), _c('span', {
    staticClass: "serif"
  }, [_vm._v("É")]), _vm._v("touff"), _c('span', {
    staticClass: "serif"
  }, [_vm._v("é")]), _vm._v("e")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/63chapter05j#ch5lev10"
    }
  }, [_c('strong', [_vm._v("Pork Chops Cordon Bleu")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/64chapter05k#ch5lev11"
    }
  }, [_c('strong', [_vm._v("Pork Chops Saltimbocca")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/65chapter05l#ch5lev12"
    }
  }, [_c('strong', [_vm._v("Pork Chops Parmigiana")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/66chapter05m#ch5lev13"
    }
  }, [_c('strong', [_vm._v("It’s a Canadian Pork Chop, Eh!")])])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/67chapter06#ch6"
    }
  }, [_vm._v("CHAPTER 6 "), _c('span', {
    staticClass: "fontb"
  }, [_vm._v("EXTREME PORK CHOPS")])])]), _vm._v(" "), _c('ul', {
    staticClass: "list"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/68chapter06a#ch6lev1"
    }
  }, [_c('strong', [_vm._v("Pork Chop–Stuffed French Toast")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/69chapter06b#ch6lev2"
    }
  }, [_c('strong', [_vm._v("Doenee’s Hawaiian Pork Chop Sandwiches")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/70chapter06c#ch6lev3"
    }
  }, [_c('strong', [_vm._v("Buffalo Hot Chop Sandwiches")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/71chapter06d#ch6lev4"
    }
  }, [_c('strong', [_vm._v("Philly Cheese Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/72chapter06e#ch6lev5"
    }
  }, [_c('strong', [_vm._v("Pig Wings with Spicy Mustard Dipping Sauce")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/73chapter06f#ch6lev6"
    }
  }, [_c('strong', [_vm._v("Pastrami Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/74chapter06g#ch6lev7"
    }
  }, [_c('strong', [_vm._v("Horseradish-Crusted Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/75chapter06h#ch6lev8"
    }
  }, [_c('strong', [_vm._v("Grilled Coffee-Crusted Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/76chapter06i#ch6lev9"
    }
  }, [_c('strong', [_vm._v("Deep-Fried Pork Chops")])])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/xhtml/77chapter06j#ch6lev10"
    }
  }, [_c('strong', [_vm._v("Jalape"), _c('span', {
    staticClass: "serif"
  }, [_vm._v("ñ")]), _vm._v("o Pork Chops")])])])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/78index#ind"
    }
  }, [_vm._v("INDEX")])])]), _vm._v(" "), _c('li', [_c('strong', [_c('a', {
    attrs: {
      "href": "#/xhtml/80author#author"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])]), _vm._v(" "), _c('div', {
    staticClass: "image_wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0008-01.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-282ecf4e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07-contents.vue
// module id = 75
// module chunks = 0